import { render, staticRenderFns } from "./FormControlOdpCourseBookingsAmountPaid.vue?vue&type=template&id=fd677a00"
import script from "./FormControlOdpCourseBookingsAmountPaid.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlOdpCourseBookingsAmountPaid.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports